import api from '../BaseUrl';
import { Portfolio } from '../Client/PublicResponse';

export type { Portfolio };

export const getPortfolio = async (): Promise<Portfolio[]> => {
  const res = await api.get<Portfolio[]>('/api/Project/AllProject');
  return res.data;
};

export const postPortfolio = async (data: Omit<Portfolio, 'id'>): Promise<void> => {
  await api.post('/api/Admin/AddProject', data);
};

export const putPortfolio = async (id: string | number, data: Omit<Portfolio, 'id'>): Promise<void> => {
  await api.put(`/api/Admin/UpdateProject/${id}`, data);
};

export const deletePortfolio = async (id: string | number): Promise<void> => {
  await api.delete(`/api/Admin/DeleteProject/${id}`);
};
